import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ClassificationsQuery } from '@app/pages/cmms/graphql/classification.queries';
import {
	ClassificationVariables,
	IClassification,
} from '@app/pages/cmms/interfaces/classification.interfaces';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ClassificationService {
	constructor(private apollo: Apollo) {}

	loadClassifications(
		variables?: ClassificationVariables
	): Observable<IClassification[]> {
		return this.apollo
			.query<IClassification[]>({
				query: ClassificationsQuery,
				variables,
				fetchPolicy: 'no-cache',
			})
			.pipe(
				map((payload: any) => {
					return payload.data.classificationsV2.edges.map(edge => edge.node);
				})
			);
	}
}
